<template>
  <div class="buyer-add-container">
    <b-row>
      <b-col :lg="8">
        <div class="form-container card">
          <div class="card-body">
            <h3 class="title-slash">
              {{ $t('buyers.add.information.title') }}
            </h3>
            <form @submit.prevent="submitBuyerForm" novalidate>
              <b-row>
                <b-col :sm="12">
                  <b-form-group
                    class="material-label-group multiselect-element"
                    @mouseenter.native="hover('country')"
                    @mouseleave.native="blur"
                  >
                    <label
                      class="material-label"
                      :class="{ empty: form.country === '' && !fieldClicked }"
                    >
                      <span>{{ $t('buyers.add.form.country') }}</span>
                    </label>
                    <!-- Pass an 'id' with multiselect to make the focus method work -->
                    <multiselect
                      v-tabindex
                      name="country"
                      v-validate="'required'"
                      data-vv-as="Buyer country"
                      v-model="form.country"
                      placeholder
                      :options="meta.COUNTRY_LIST"
                      @open="focus"
                      @close="blur"
                      id="country"
                    />
                    <span class="error">{{ errors.first('country') }}</span>
                  </b-form-group>
                  <help-text keyword="country" :element="currentElement" />
                </b-col>
                <b-col :sm="12">
                  <b-form-group
                    @mouseenter.native="hover('name')"
                    @mouseleave.native="blur"
                  >
                    <label
                      class="material-label"
                      :class="{
                        empty:
                          form.name === '' && currentElementSelected !== 'name'
                      }"
                    >
                      <span>{{ $t('buyers.add.form.name') }}</span>
                      <b-form-input
                        name="name"
                        type="text"
                        v-validate="'required'"
                        data-vv-as="Buyer name"
                        v-model="form.name"
                        @focus.native="focus"
                        @blur.native="blur"
                      ></b-form-input>
                      <span class="error">
                        {{ errors.first('name') }}
                      </span>
                    </label>
                  </b-form-group>
                  <help-text keyword="name" :element="currentElement" />
                </b-col>
                <b-col :sm="12">
                  <b-form-group
                    @mouseenter.native="hover('address')"
                    @mouseleave.native="blur"
                  >
                    <label
                      class="material-label"
                      :class="{
                        empty:
                          form.address === '' &&
                          currentElementSelected !== 'address'
                      }"
                    >
                      <span>{{ $t('buyers.add.form.address') }}</span>
                      <b-form-textarea
                        name="address"
                        rows="3"
                        v-validate="'required'"
                        data-vv-as="Buyer address"
                        @focus.native="focus"
                        @blur.native="blur"
                        v-model="form.address"
                      ></b-form-textarea>
                      <span class="error">
                        {{ errors.first('address') }}
                      </span>
                    </label>
                  </b-form-group>
                  <help-text keyword="address" :element="currentElement" />
                </b-col>
              </b-row>
              <form-button
                type="submit"
                variant="secondary"
                @click="stepChange('back')"
                class="mr-2"
              >
                {{ $t('buyers.add.form.back') }}
              </form-button>
              <form-button
                :loading="loading"
                type="submit"
                variant="primary"
                class="float-right float-md-none"
              >
                {{ $t('buyers.add.form.next') }}
              </form-button>
            </form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import meta from '@/assets/application.india'
import Multiselect from 'vue-multiselect'
import FormButton from '@/components/common/FormButton'
import HelpText from '@/components/buyers/HelpText'
import buyersService from '@/services/buyers'
import { popupErrorMessage } from '@/helpers/errorHandlers'

export default {
  data() {
    return {
      loading: false,
      meta: meta,
      upHere: false,
      booleanOptions: ['Yes', 'No'],
      currentElement: '',
      currentElementSelected: '',
      fieldClicked: false
    }
  },
  methods: {
    submitBuyerForm() {
      return this.$validator.validate().then((result) => {
        if (result) {
          return this.addBuyerInformation()
        }
      })
    },
    stepChange(where) {
      if (where === 'back') {
        this.$mpTrack('Add Buyer - Go back to Uploads')
        return this.$emit('prevStep')
      } else {
        this.$mpTrack('Add Buyer - Go to Operations')
        return this.$emit('nextStep')
      }
    },
    focus(e) {
      if (e === 'country') {
        this.fieldClicked = true
      }
      this.currentElement = this.currentElementSelected = !e.target
        ? e
        : e.target.name
    },
    hover(e) {
      this.currentElement = e
    },
    blur() {
      this.fieldClicked = false
      this.currentElement = this.currentElementSelected = ''
    },
    addBuyerInformation() {
      this.loading = true
      return buyersService
        .modifyBuyersDraft(this.$route.params.buyerId, {
          draft: {
            task: 'customer_buyer_data',
            data: {
              buyer_form: this.form
            }
          }
        })
        .then((res) => {
          this.loading = false
          this.$mpTrack('Buyer Information Added Successfully')
          return this.stepChange()
        })
        .catch((err) => {
          popupErrorMessage(err)
          this.loading = false
        })
    }
  },
  mounted() {
    this.$mpTrack('Add Buyer - Buyer Buyer information page loaded')
    this.$emit('loadBuyer')
  },
  props: ['form', 'buyer'],
  components: {
    HelpText,
    FormButton,
    Multiselect
  },
  directives: {
    tabindex: {
      inserted(el) {
        el.setAttribute('tabindex', 0)
      }
    }
  }
}
</script>
<style lang="scss">
.buyer-add-container {
  padding-bottom: 50px;
}
</style>
